<template>
    <div class="inline-block relative flex-shrink-0" ref="containerRef">
        <div
            class="group inline-flex items-center gap-1 h-[32px] px-2 rounded-full border transition-all duration-200 cursor-pointer select-none"
            :class="open ? 'border-eureka-500' : 'border-gray-40'"
            @click="toggleDropdown"
        >
            <span class="text-sm text-gray-900">{{ currentOption.label }}</span>
            <PtIcon icon="SolidArrowDown" class="fill-black text-[18px]" />
        </div>

        <!-- 下拉菜单 -->
        <ul
            v-show="open"
            class="th-dropdown-content th-menu absolute left-0 top-[36px] z-10 w-[160px] bg-white rounded-md shadow-md border border-gray-40 p-1"
        >
            <li
                v-for="option in options"
                :key="option.value"
                class="flex items-center gap-2 px-3 py-2 rounded cursor-pointer text-sm transition-colors duration-150"
                :class="modelValue === option.value ? 'bg-eureka-40 text-eureka-500' : 'text-gray-900 hover:bg-gray-100'"
                @click="select(option.value)"
            >
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { PtIcon } from 'patsnap-biz';
import { onClickOutside } from '@vueuse/core';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';
import { WorkMode } from '@/features/drafting/constants/enum';

interface Props {
    modelValue?: WorkMode;
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: WorkMode.AGENT,
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: WorkMode): void;
}>();

const { t } = useI18n({
    messages: {
        cn: {
            reviewEachStep: '逐步审阅',
            autoComplete: '自动完成',
        },
        en: {
            reviewEachStep: 'Review each step',
            autoComplete: 'Auto complete',
        },
        jp: {
            reviewEachStep: 'ステップごとに確認',
            autoComplete: '自動完成',
        },
    },
});

const open = ref(false);
const containerRef = ref<HTMLElement | null>(null);

const options = computed(() => [
    { value: WorkMode.AGENT, label: t('reviewEachStep') },
    { value: WorkMode.COPILOT, label: t('autoComplete') }
]);

const currentOption = computed(() => options.value.find(o => o.value === props.modelValue) ?? options.value[0]);

onClickOutside(containerRef, () => { open.value = false; });

function toggleDropdown() {
    open.value = !open.value;
}

function select(value: WorkMode) {
    emit('update:modelValue', value);
    open.value = false;
}
</script>
